import {useMemo} from "react";
import {useQuery} from "@tanstack/react-query";
import api from "../../utils/api";
import type {VendorRecord} from "./types";
import {buildVendorDirectoryData} from "./utils";

const getVendors = async (): Promise<VendorRecord[]> => {
    const res = await api.get('/vendors');
    return Array.isArray(res.data) ? res.data as VendorRecord[] : [];
};

export default function useVendorsData() {
    const vendorsQuery = useQuery<VendorRecord[]>({
        queryKey: ['vendors'],
        queryFn: getVendors,
        staleTime: 1000 * 60 * 5,
    });

    const directory = useMemo(() => {
        return buildVendorDirectoryData(vendorsQuery.data ?? []);
    }, [vendorsQuery.data]);

    return {
        ...directory,
        isPending: vendorsQuery.isPending,
        isError: vendorsQuery.isError,
        error: vendorsQuery.error,
        refetch: vendorsQuery.refetch,
    };
}
